import React from 'react'

export const Hamburger = () => (
  <svg viewBox="0 0 100 80" width="20" height="12">
    <rect width="100" height="10"></rect>
    <rect y="30" width="100" height="10"></rect>
    <rect y="60" width="100" height="10"></rect>
  </svg>
)
